import React from 'react';
import styled from 'styled-components';
import AmeSymbol from '@catalogo/ui-americanas-desktop-svg/ame-white.svg';
import IconDoubt from '@catalogo/ui-americanas-desktop-svg/icon-attendance-doubt.svg';
import { Text } from '@catalogo/theme-text';
import { withRouter } from 'react-router';
import { replaceUrlParams } from '@catalogo/service-americanas-product/src/helpers/url';

export const Supercashback = ({ hasSuperCashback, contentModalAme, history }) => {
  if (!hasSuperCashback) {
    return null;
  }

  return (
    <AmeContainer>
      <Flexbox variant="vertical">
        <AmeView>
          <AmeSymbolUI height={20} width={18} />
          <AmeText>
            <b>super cashback</b>
          </AmeText>
        </AmeView>
        <Cell>
          <ClickableIconDoubt
            height={10}
            width={10}
            fill="#fff"
            onClick={replaceUrlParams(history, '#modal-ame-supercashback-info', false, {
              publication: contentModalAme,
            })}
          />
        </Cell>
      </Flexbox>
    </AmeContainer>
  );
};

const AmeContainer = styled.div`
  align-items: center;
  border-radius: 4px;
  margin-bottom: 20px;
  background: linear-gradient(158.68deg, #ed0059 0%, #620070 76.66%, #170085 100%);
`;

const AmeView = styled.div`
  flex-direction: row;
  margin-right: 0;
  flex: 1;
  text-align: center;
`;

const AmeSymbolUI = styled(AmeSymbol)`
  vertical-align: middle;
`;

const AmeText = styled(Text)`
  color: #fff;
  margin-left: 5px;
  font-size: 14px;
  vertical-align: middle;
`;

const ClickableIconDoubt = styled(IconDoubt)`
  margin-right: 12px;
  cursor: pointer;
`;

const Flexbox = styled.div`
  width: 100%;
  padding: 3px 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

const Cell = styled.div`
  flex: 0;
`;

export default withRouter(Supercashback);
